import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TFiscalReportsStore,
	TFiscalVatListInfoFilterResponsePayload,
	TFiscalReportListResponsePayload,
	TFiscalReportListRequest,
	TDownloadFiscalPdfRequest,
	TDownloadFiscalPdfResponsePayload,
	TDownloadFiscalCsvRequest,
	TDownloadFiscalCsvResponsePayload,
	TDownloadFiscalXlsxRequest,
	TDownloadFiscalXlsxResponsePayload,
	TExportFiscalXlsxRequest,
	TExportFiscalXlsxResponsePayload,
	TUpdateFiscalReportPaymentRequest,
	TUpdateFiscalReportPaymentResponsePayload,
	TUpdateFiscalReportCommentRequest,
	TUpdateFiscalReportCommentResponsePayload,
	TSendPaidResponsePayload,
	TSendReportRequest,
	TSendReportResponsePayload,
	TCancelReportRequest,
	TCancelReportResponsePayload,
} from './types';

const initialState: TFiscalReportsStore = {
	fiscalVatListInfoFilter: null,
	fiscalVatListInfoFilterLoader: false,
	fiscalReportList: null,
	fiscalReportListLoader: false,
	downloadFiscalPdfLoader: false,
	downloadedFiscalPdf: null,
	downloadFiscalCsvLoader: false,
	downloadedFiscalCsv: null,
	downloadFiscalXlsxLoader: false,
	downloadedFiscalXlsx: null,
	exportFiscalXlsxLoader: false,
	exportedFiscalXlsx: null,
	updateFiscalReportPaymentLoader: false,
	updateFiscalReportCommentLoader: false,
	sendPaidLoader: false,
	sendReportLoader: false,
	cancelReportLoader: false,
};

const fiscalReportsSlice = createSlice({
	name: 'fiscalReports',
	initialState,
	reducers: {
		getFiscalVatListInfoFilterRequest: state => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalVatListInfoFilterLoader = true;
		},
		getFiscalVatListInfoFilterSuccess: (
			state,
			action: PayloadAction<TFiscalVatListInfoFilterResponsePayload>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalVatListInfoFilter = action.payload;
			// eslint-disable-next-line no-param-reassign
			state.fiscalVatListInfoFilterLoader = false;
		},
		getFiscalVatListInfoFilterFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalVatListInfoFilterLoader = false;
		},
		getFiscalReportListRequest: (state, action: PayloadAction<TFiscalReportListRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalReportListLoader = true;
		},
		getFiscalReportListSuccess: (
			state,
			action: PayloadAction<TFiscalReportListResponsePayload>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalReportList = action.payload;
			// eslint-disable-next-line no-param-reassign
			state.fiscalReportListLoader = false;
		},
		getFiscalReportListFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.fiscalReportListLoader = false;
		},
		downloadFiscalPdfRequest: (state, action: PayloadAction<TDownloadFiscalPdfRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalPdfLoader = true;
		},
		downloadFiscalPdfSuccess: (state, action: PayloadAction<TDownloadFiscalPdfResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalPdfLoader = false;
			// eslint-disable-next-line no-param-reassign
			state.downloadedFiscalPdf = action.payload;
		},
		downloadFiscalPdfFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalPdfLoader = false;
		},
		downloadFiscalCsvRequest: (state, action: PayloadAction<TDownloadFiscalCsvRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalCsvLoader = true;
		},
		downloadFiscalCsvSuccess: (state, action: PayloadAction<TDownloadFiscalCsvResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalCsvLoader = false;
			// eslint-disable-next-line no-param-reassign
			state.downloadedFiscalCsv = action.payload;
		},
		downloadFiscalCsvFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalCsvLoader = false;
		},
		downloadFiscalXlsxRequest: (state, action: PayloadAction<TDownloadFiscalXlsxRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalXlsxLoader = true;
		},
		downloadFiscalXlsxSuccess: (
			state,
			action: PayloadAction<TDownloadFiscalXlsxResponsePayload>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalXlsxLoader = false;
			// eslint-disable-next-line no-param-reassign
			state.downloadedFiscalXlsx = action.payload;
		},
		downloadFiscalXlsxFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.downloadFiscalXlsxLoader = false;
		},
		updateFiscalReportPaymentRequest: (
			state,
			action: PayloadAction<TUpdateFiscalReportPaymentRequest>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportPaymentLoader = true;
		},
		updateFiscalReportPaymentSuccess: (
			state,
			action: PayloadAction<TUpdateFiscalReportPaymentResponsePayload>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportPaymentLoader = false;
		},
		updateFiscalReportPaymentFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportPaymentLoader = false;
		},
		updateFiscalReportCommentRequest: (
			state,
			action: PayloadAction<TUpdateFiscalReportCommentRequest>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportCommentLoader = true;
		},
		updateFiscalReportCommentSuccess: (
			state,
			action: PayloadAction<TUpdateFiscalReportCommentResponsePayload>,
		) => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportCommentLoader = false;
		},
		updateFiscalReportCommentFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.updateFiscalReportCommentLoader = false;
		},
		exportFiscalXlsxRequest: (state, action: PayloadAction<TExportFiscalXlsxRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.exportFiscalXlsxLoader = true;
		},
		exportFiscalXlsxSuccess: (state, action: PayloadAction<TExportFiscalXlsxResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.exportFiscalXlsxLoader = false;
			// eslint-disable-next-line no-param-reassign
			state.exportedFiscalXlsx = action.payload;
		},
		exportFiscalXlsxFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.exportFiscalXlsxLoader = false;
		},
		sendPaidRequest: state => {
			// eslint-disable-next-line no-param-reassign
			state.sendPaidLoader = true;
		},
		sendPaidSuccess: (state, action: PayloadAction<TSendPaidResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.sendPaidLoader = false;
		},
		sendPaidFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.sendPaidLoader = false;
		},
		sendReportRequest: (state, action: PayloadAction<TSendReportRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.sendReportLoader = true;
		},
		sendReportSuccess: (state, action: PayloadAction<TSendReportResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.sendReportLoader = false;
		},
		sendReportFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.sendReportLoader = false;
		},
		cancelReportRequest: (state, action: PayloadAction<TCancelReportRequest>) => {
			// eslint-disable-next-line no-param-reassign
			state.cancelReportLoader = true;
		},
		cancelReportSuccess: (state, action: PayloadAction<TCancelReportResponsePayload>) => {
			// eslint-disable-next-line no-param-reassign
			state.cancelReportLoader = false;
		},
		cancelReportFailure: state => {
			// eslint-disable-next-line no-param-reassign
			state.cancelReportLoader = false;
		},
	},
});

export const {
	getFiscalVatListInfoFilterRequest,
	getFiscalVatListInfoFilterSuccess,
	getFiscalVatListInfoFilterFailure,
	getFiscalReportListRequest,
	getFiscalReportListSuccess,
	getFiscalReportListFailure,
	downloadFiscalPdfRequest,
	downloadFiscalPdfSuccess,
	downloadFiscalPdfFailure,
	downloadFiscalCsvRequest,
	downloadFiscalCsvSuccess,
	downloadFiscalCsvFailure,
	downloadFiscalXlsxRequest,
	downloadFiscalXlsxSuccess,
	downloadFiscalXlsxFailure,
	exportFiscalXlsxRequest,
	exportFiscalXlsxSuccess,
	exportFiscalXlsxFailure,
	updateFiscalReportPaymentRequest,
	updateFiscalReportPaymentSuccess,
	updateFiscalReportPaymentFailure,
	updateFiscalReportCommentRequest,
	updateFiscalReportCommentSuccess,
	updateFiscalReportCommentFailure,
	sendPaidRequest,
	sendPaidSuccess,
	sendPaidFailure,
	sendReportRequest,
	sendReportSuccess,
	sendReportFailure,
	cancelReportRequest,
	cancelReportSuccess,
	cancelReportFailure,
} = fiscalReportsSlice.actions;
export default fiscalReportsSlice.reducer;
